import Signin from './signin/Index.vue';
import PasswordResetForm from './passwordresetform/Index.vue';
import PasswordChangeForm from './passwordchangeform/index';

export default {
	Signin,
	PasswordResetForm,
	PasswordChangeForm
}
